export default {
	"SeckillComponent.HotRush": "火热抢购中",
	"SeckillComponent.ComingSoon": "即将开始",
	"SeckillComponent.OnlyTheEndIsLeft": "距离结束只剩",
	"SeckillComponent.LimitedTimeSpikes": "限时秒杀",
	"SeckillComponent.sky": "天"
}